import React, { useCallback } from 'react';

import { PreviewPanelsProvider } from '@atlassian/preview-panels-api';

import { useCloseAllOpenSidePanels } from './useCloseAllOpenSidePanels';

export const ConfluencePreviewPanelsProvider = ({ children }: { children: React.ReactNode }) => {
	const { closeAllOpenSidePanels } = useCloseAllOpenSidePanels();

	const productHandleOpen = useCallback(() => {
		// Add any additional logic here for opening preview panels.
	}, []);

	const productHandleClose = useCallback(() => {
		// Add any additional logic here for closing preview panels.
		closeAllOpenSidePanels();
	}, [closeAllOpenSidePanels]);

	return (
		<PreviewPanelsProvider
			productHandleOpen={productHandleOpen}
			productHandleClose={productHandleClose}
		>
			{children}
		</PreviewPanelsProvider>
	);
};
